(function () {
  var global_event_listener;
  var pref_time = Date.now();
  var nav_starttime;

  window.navigating = false;
  window.active_page = undefined;
  window.active_page_id = undefined;
  window.pageHistory = [];

  /**
   * List of page redirects.
   * @type {{pageId: string, redirectTo: string, onRedirect: () => boolean | void}[]}
   */
  window.redirects = [];

  function makeClickable() {
    if (global_event_listener) {
      return true;
    }

    $(document.body).on(event_link, '[href]', function (e) {
      navigate(this.getAttribute('href'), this.getAttribute('href_type'));
      return false;
    });

    $(document.body).on(event_link, '[onvclick]', function (e) {
      runAction.call(this, 'onvclick');
      return false;
    });

    $(document.body).on(event_double_click, '[onvdoubleclick]', function (e) {
      runAction.call(this, 'onvdoubleclick');
      return false;
    });

    $(document.body).on(event_action_move, '[onvmove]', function (e) {
      runAction.call(this, 'onvmove');
      return false;
    });

    $(document.body).on(event_action_leave, '[onvleave]', function (e) {
      runAction.call(this, 'onvleave');
      return false;
    });

    global_event_listener = true;

    var runAction = (function () {
      if (tv_desktop_mark) {
        return function (type) {
          // eslint-disable-next-line no-eval
          eval(this.getAttribute(type));
        };
      } else {
        return function (type) {
          try {
            // eslint-disable-next-line no-eval
            eval(this.getAttribute(type));
          } catch (e) {
            log.add(e.message);
          }
        };
      }
    })();
  }

  function pref_log(text) {
    var now = Date.now();
    //TODO: if debug
    //console.log(text + ': ' + (now - pref_time));
    pref_time = now;
  }

  function navigateBack() {
    return navigate(null, 'back');
  }

  // LEGACY:
  // There is a need to use such functionality due to the fact
  // that there were innovations breaking the navigation
  // which admin panel assuming
  // Need to be deleted, when header's back
  // for new pages will be removed
  var excludedPageClassesFromHrefNavigation = [
    'custom_information_page',
    'information-list-hub',
    'custom_information_list',
  ];

  function isPageExcludedFromHrefNavigation(pageId) {
    var page = $(pageId);
    for (var i = 0; i < excludedPageClassesFromHrefNavigation.length; i++) {
      if (page.hasClass(excludedPageClassesFromHrefNavigation[i])) {
        return true;
      }
    }
    return false;
  }

  /**
   * Navigates to a specified page
   * @param {string} to - Target page selector (e.g., '#menu', '#page-id')
   * @param {string} [type] - Navigation type: 'back', 'notification', 'popup', or undefined
   * @param {boolean} [dontsave] - If true, doesn't save page to history, it's workaround for rerenderable pages (if you go back on rerenderable page, it's content is not as previous)
   * @param {boolean} [not_fit_text] - If true, skips text fitting operations
   * @returns {jQuery.Deferred} Promise that resolves when navigation is complete
   */
  function navigate(to, type, dontsave, not_fit_text) {
    var d = $.Deferred();

    // kill third-party web app on navigation
    // TODO: is that required on non-Tizen TVs?
    if (_third_party_app) {
      _third_party_app.close();
    }

    to = checkRedirect(to);

    if (type === 'back') {
      // LEGACY:
      // "to" set for 'back' type means that page using href navigation type,
      // so cleaning pageHistory to avoid href navigation problems
      // BUT if it's equal to HoezaTV.history.lastpage means
      // using pageHistory navigation
      if (to && to !== HotezaTV.history.lastpage && !isPageExcludedFromHrefNavigation(to)) {
        // Do nothing, but for cases with wrong ids using history navigation
        if ($(to).length === 0) {
          to = popPreviousPage();
        } else {
          // LEGACY: look back to the page that we want to return to and remove odd pages
          var i;
          for (i = pageHistory.length - 1; i >= 0; i--) {
            if (pageHistory[i].to === to) {
              pageHistory.splice(i + 1);
              break;
            }
          }
          // For the case there is no to page in pageHistory
          if (i <= 0) {
            pageHistory = [{to: to, id: to.replace(/^#/, '')}];
          }
        }
      } else {
        to = popPreviousPage();
      }
    }

    var id = to.replace(/^#/, '');

    // FIXME: Problem in final confirmation of order and then in success because #info page
    // Check if trying to navigate to the same page
    if (id === active_page_id) {
      log.add('NAVIGATION TO SAME PAGE: ' + id);
    }

    // блокировка навигации menu->menu
    if (to == '#menu' && tv_cur_block == 'menu') {
      console.log('Menu2menu blocked');
      d.reject('menu2menu');
      return d.promise();
    }

    if (navigating) {
      d.reject('nav in progress');
      return d.promise();
    }

    nav_starttime = Date.now();
    pref_log('start');

    // TODO: выход из текущего модуля
    if (fullscreen) {
      tv_mode();
    }

    hideInputBlocks();

    if (!$id(id) && !UI.hasPage(id)) {
      console.log('Page ' + id + ' do not exist');
      d.reject('not exist');
      return d.promise();
    }

    // Перехват новой навигации
    if (UI.hasPage(id)) {
      navigating = true;
      UI.navigate(id)
        .done(function () {
          pref_log('nav');
          //TODO: сделать возможность делать nav после onopen (или вместо)
          if ($id(id)) {
            nav();
          } else {
            d.reject('Navigating without page: ' + id);
            console.log('Navigating without page: ' + id);
          }
        })
        .fail(function (error) {
          console.log('New navigation failed: ' + error);
          d.reject('new nav fail');
        })
        .always(function () {
          navigating = false;
        });
      return d.promise();
    }

    // TODO: don't stop media only on some cases. Remade in normal way
    if (
      type !== 'notification' &&
      type !== 'popup' &&
      Media.type != null &&
      tv_cur_block !== 'popup' &&
      id !== 'tv_mosaic'
    ) {
      Media.stop({directType: null}).done(() => {
        if (Vendor.get() === 'lg') {
          setTimeout(() => {
            nav();
          }, 100);
        } else {
          nav();
        }
      });
      // Media.stop({ directType: null }).done(nav);
    } else {
      nav();
    }

    return d.promise();

    /**
     * Internal function that performs the actual navigation
     * Handles page transitions, animations, history management, and triggers page lifecycle events
     * @inner
     */
    function nav() {
      var from_page;
      var to_page = $(to);

      if (id == 'menu' || tv_cur_block == 'menu') {
        menuVisibilityControl(id);
      }

      if (active_page !== to) {
        navigating = true;

        //выделение в меню
        setActiveMenuItem();

        if (active_page && $(active_page).length) {
          from_page = $(active_page);
          from_page[0].style[window.css_transition] = '';
        }

        if (to === '#menu') {
          tv_menu(from_page);
          active_page = '';
          active_page_id = '';

          pageHistory = [];
        } else {
          if (from_page) {
            if (!to_page.hasClass('popup')) {
              from_page.hide();
              from_page.removeClass('active_page away_page l r');
            }
          }

          to_page.addClass('active_page').show();

          active_page = to;
          active_page_id = id;

          if (active_page && !dontsave && type !== 'back') {
            pageHistory.push({to: active_page, id: active_page_id});
          }
        }
        pref_log('navigation');

        if (!not_fit_text) {
          fit_text(to_page.find('.header h1'), 20, true);
          fit_text(to_page.find('.pagelist li>span'));
        }
        pref_log('fittext');

        navigating = false;

        // перемотка контента на начало
        if (from_page) {
          if (!from_page[0].getAttribute('keep_position') && from_page.find('.content')[0]) {
            var tmp = from_page.find('.content')[0].style;
            tmp[window.css_transition] = window.css_transform + ' 0s';
            tmp[window.css_transform] = 'translate3d(0,0,0)';
          }
        }
        pref_log('keep pos');

        // Page visit stat
        $(HotezaTV).trigger('stat_page', id);
        pref_log('page stat');

        // используется id вместо active_page_id
        // так как active_page_id не может быть равен menu
        tv_sel_block(id);
        pref_log('sel_block took');

        // Построение прокрутки страниц
        if (to_page.hasClass('information_list_classic') || to_page.hasClass('shop_products_classic')) {
          make_scroll(to_page, to_page.find('.sidebar-left'), 'left');
          make_scroll(to_page, to_page.find('.sidebar-right'), 'right');
        } else {
          make_scroll(to_page);
        }
        pref_log('scroll');

        // Изменение высоты контента под размер окна
        if (to_page[0] && to_page[0].getAttribute('scroll_to_bottom')) {
          scroll_to_bottom(to_page);
        }
        pref_log('to bottom');
      } else {
        to_page[0].style.display = 'block';
        to_page.addClass('active_page');
        tv_sel_block(active_page_id);
        pref_log('current nav');
      }

      // Сохранение последней страницы
      if (!dontsave && !parseInt(to_page.attr('data-dont-save'))) {
        HotezaTV.history.lastpage = to;
      }

      // перенес сюда, т.к при переходе на shopitem
      // lastpage не назначался
      manageBodyClasses(to);

      // Выполнение действий по закрытии страницы
      execAction(from_page, 'close');
      // Выполнение действий по открытии страницы
      execAction(to_page, 'open');
      pref_log('exec');

      console.log('Total:' + (Date.now() - nav_starttime));
      d.resolve();
    }

    // TODO: отвратительные костыли. убрать когда разделятся меню и велком
    function menuVisibilityControl(_id) {
      // если dialog вызывался в меню,
      // например отсутствие каналов
      // меню скрывалось
      if (_id !== 'dialog' && _id !== 'notification_container' && (metro_menu || scandic_menu || custom_menu)) {
        if (_id === 'menu') {
          show_menu();
        } else {
          hide_menu();
        }
      }
    }

    /**
     * Hides input blocks (INPUT and TEXTAREA elements) by removing focus
     * @inner
     */
    function hideInputBlocks() {
      if (document.activeElement) {
        var tmp = document.activeElement.tagName;
        if (tmp === 'INPUT' || tmp === 'TEXTAREA') {
          document.activeElement.blur();
        }
      } else {
        if ($('INPUT:focus, TEXTAREA:focus').length) {
          $('*:focus').blur();
        }
      }
    }

    function setActiveMenuItem() {
      var tre = $('#menu [href="' + to + '"]')[0];

      if (tre) {
        if (!tre.classList.contains('active')) {
          var tmp_o = document.getElementById('menu').querySelectorAll('.active');
          for (var i = 0, tmp_l = tmp_o.length; i < tmp_l; i++) {
            tmp_o[i].classList.remove('active');
          }
          tre.classList.add('active');
        }
      }
    }

    /**
     * Returns the previous page from history or '#menu' as default
     * Handles legacy navigation cases and page history cleanup
     * @inner
     * @returns {string} Previous page selector
     */
    function popPreviousPage() {
      if (pageHistory.length > 0) {
        // LEGACY:
        // If page is not in pageHistory, it was navigated with
        // dontsave param (seems to be rerenderable pages)
        while (pageHistory.length > 0 && pageHistory[pageHistory.length - 1].to === active_page) {
          // Remove current page
          // Even if was referenced multiple times
          pageHistory.pop();
        }

        if (pageHistory.length > 0) {
          // Get the previous page
          var previousPage = pageHistory[pageHistory.length - 1];
          return previousPage.to;
        } else {
          return '#menu';
        }
      } else {
        return '#menu';
      }
    }
  }

  function make_scroll(to, context, suffix) {
    if (!to || !to.length) {
      return false;
    }

    var searchRoot = context || to;
    var c = searchRoot.find('.content');
    var ch;
    var visibleSpace;

    var scrollId = suffix ? to[0].id + '_' + suffix + '_scroll' : to[0].id + '_scroll';
    var scrollInnerId = scrollId + '_inner';

    // Page variant: .sidebar-right contains .right-col-scroll-area with .right-col-content
    // The .content--page has height:100% so it never overflows; the actual scrollable content
    // is .right-col-content inside .right-col-scroll-area
    var rightColScrollArea = searchRoot.find('.right-col-scroll-area');
    if (rightColScrollArea.length) {
      c = rightColScrollArea.find('.right-col-content');
      visibleSpace = rightColScrollArea;
      ch = visibleSpace.height();
    }

    if (
      to[0].id === 'time_picker' ||
      to[0].id === 'welcome' ||
      to[0].id === 'weather_select_location' ||
      to[0].id === 'tv_mosaic' ||
      to[0].id === 'radio_page'
    ) {
      return false;
    } else if (!ch && searchRoot.hasClass('content_wrapper')) {
      visibleSpace = searchRoot;
      ch = visibleSpace.height();
    } else if (!ch && searchRoot.find('.content_wrapper').length) {
      visibleSpace = searchRoot.find('.content_wrapper');
      ch = visibleSpace.height();
    }

    var scroll = getScroll();
    if (c.outerHeight() > ch) {
      if (!scroll.length) {
        var appendTarget = context ? visibleSpace || context : to;
        appendTarget.append(
          '<div id="' +
            scrollId +
            '" class="page_scroll">' +
            '<div id="' +
            scrollInnerId +
            '" class="page_scroll_inner"></div>' +
            '</div>',
        );

        scroll = getScroll();
        scroll.css({
          top: context ? 0 : parseInt(visibleSpace.css('top')),
          height: ch,
        });
        $id(scrollInnerId).container_height = ch;
      }

      resize_scroll(to, suffix, context);
    } else if (scroll) {
      scroll.remove();
    }

    function getScroll() {
      return $('#' + scrollId);
    }
  }

  function resize_scroll(to, suffix, context) {
    if (!to || !to.length) {
      return false;
    }

    var searchRoot = context || to;
    var c = searchRoot.find('.content');
    var ch;
    var c_h;

    // Page variant: measure .right-col-content instead of .content
    var rightColScrollArea = searchRoot.find('.right-col-scroll-area');
    if (rightColScrollArea.length) {
      c = rightColScrollArea.find('.right-col-content');
    }

    // фикс высоты страницы welcome
    if (to[0].id === 'welcome') {
      return;
    }

    var scrollInnerId = suffix ? to[0].id + '_' + suffix + '_scroll_inner' : to[0].id + '_scroll_inner';
    var scroll_inner = $id(scrollInnerId);
    // если на странице нет скролла
    if (!scroll_inner) {
      return;
    }

    c_h = c.outerHeight();
    ch = scroll_inner.container_height;

    var tmp = ((ch * ch) / c_h) | 0;
    if (ch / c_h < 1) {
      scroll_inner.style.height = tmp + 'px';
    }

    scroll_inner.coef = ch / c_h;
    scroll_inner.max = ch - tmp;
  }

  function scroll_to_top(page) {
    if (!page) {
      page = $(active_page);
    }

    if (page[0] && (page.hasClass('information_list_classic') || page.hasClass('shop_products_classic'))) {
      var sidebarLeftContent = page.find('.sidebar-left .content')[0];
      var sidebarRightContent = page.find('.sidebar-right .content')[0];
      var rightColContent = page.find('.right-col-content')[0];

      if (sidebarLeftContent) {
        sidebarLeftContent.style.top = '0px';
      }
      if (sidebarRightContent) {
        sidebarRightContent.style.top = '0px';
      }
      if (rightColContent) {
        rightColContent.style.top = '0px';
      }

      var pageId = page.attr('id');
      move_scroll(0, pageId, 'left');
      move_scroll(0, pageId, 'right');
    } else {
      if (page[0] && page.find('.content')[0]) {
        page.find('.content')[0].style.top = '0px';
      }

      move_scroll(0);
    }
  }

  function scroll_to_bottom(page) {
    if (!page) {
      page = $(active_page);
    }

    if (page[0]) {
      var scroll_hidden = false;
      if (page.css('display') === 'none') {
        page.css('visibility', 'hidden').show();
        scroll_hidden = true;
      }

      // TODO: support multiple scrollables
      var content_wrapper = page.find('.content_wrapper');
      var content = content_wrapper.find('.content');

      if (content[0]) {
        content[0].style.top = Math.min(0, content_wrapper.height() - content.height()) + 'px';
        scrollInnerToBottom(page);
      }

      if (scroll_hidden) {
        page.hide().css('visibility', '');
      }
    }
  }

  function scrollInnerToBottom(page) {
    var scrollInner = page.find('.page_scroll_inner')[0];

    if (scrollInner) {
      scrollInner.style.top = scrollInner.max + 'px';
    }
  }

  /**
   * Register page redirect. Using this will redirect navigation from one page to another.
   * @param {string | number} pageId The ID of the page that, when navigated to, should result in a redirect to another page.
   * @param {string | number} redirectTo The target ID of the page where the redirect should lead.
   * @param {() => boolean | void} onRedirect Optional callback called on every redirect. You could return false from it to stop redirecting.
   */
  function registerRedirect(pageId, redirectTo, onRedirect) {
    if (!pageId || !redirectTo) {
      log.add('[NAV.registerRedirect] Not enough arguments.');
      return;
    }

    // Remove existing redirects
    unRegisterRedirect(pageId);

    // Add a new one
    window.redirects.push({
      pageId: pageId.toString(),
      redirectTo: redirectTo.toString(),
      onRedirect: onRedirect,
    });
  }

  /**
   * Remove page redirect rule record.
   * @param {string | number} pageId source page id
   */
  function unRegisterRedirect(pageId) {
    if (!pageId) {
      return;
    }
    pageId = pageId.toString();
    window.redirects = window.redirects.filter(function (redirectRule) {
      return redirectRule.pageId !== pageId;
    });
  }

  /**
   * Check the page ID, if it has a registered redirect.
   * If so, the new target page ID will be returned.
   * If not, the original page ID will be returned.
   * @param {string} targetPageId target page ID. It could be a selector with #.
   * @return {string} The new target page ID (or #selector), taking into account all redirects.
   */
  function checkRedirect(targetPageId) {
    if (!targetPageId) {
      return targetPageId;
    }
    var redirect;
    var hasHash = false;
    var pageId = targetPageId;

    if (pageId.startsWith('#')) {
      hasHash = true;
      pageId = pageId.slice(1);
    }

    // loop to support redirect chains
    while (
      (redirect = window.redirects.find(function (rule) {
        return rule.pageId === pageId;
      }))
    ) {
      if (redirect.onRedirect && typeof redirect.onRedirect === 'function') {
        try {
          var result = redirect.onRedirect();
          if (result === false) {
            // prevent redirect
            break;
          }
        } catch (err) {
          log.add('[NAV] Unable to execute custom redirect callback. Unexpected error. ' + err);
          console.error(err);
        }
      }
      pageId = redirect.redirectTo;
    }

    if (hasHash) {
      pageId = '#' + pageId;
    }

    if (targetPageId !== pageId) {
      log.add('[NAV] Redirecting from ' + targetPageId + ' to ' + pageId + '...');
    }

    return pageId;
  }

  window.makeClickable = makeClickable;
  window.pref_log = pref_log;
  window.navigateBack = navigateBack;
  window.navigate = navigate;
  window.make_scroll = make_scroll;
  window.resize_scroll = resize_scroll;
  window.scroll_to_top = scroll_to_top;
  window.scroll_to_bottom = scroll_to_bottom;
  window.registerRedirect = registerRedirect;
  window.unRegisterRedirect = unRegisterRedirect;
})();
